import { render, staticRenderFns } from "./Tiempos_Libres.vue?vue&type=template&id=995c746a&scoped=true"
import script from "./Tiempos_Libres.vue?vue&type=script&lang=js"
export * from "./Tiempos_Libres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995c746a",
  null
  
)

export default component.exports